"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _Overlay = _interopRequireDefault(require("ol/Overlay"));

require("./BasePopup.css");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["map", "position", "onClose", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Component to allow to show a window popup in the ol/Map.
 * It is a window-like version of the component 
 * <i>Base Popup</i> on which the title is available and
 * the user can hide/unhide the contents.
 * 
 * @visibleName Base Popup 
 */
var BasePopup = function BasePopup(_ref) {
  var map = _ref.map,
      position = _ref.position,
      onClose = _ref.onClose,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var popupRef = (0, _react.useRef)();
  var popupCloserRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      overlay = _useState2[0],
      setOverlay = _useState2[1]; // const previousExpanded = usePrevious(expanded);
  // if(expanded !== previousExpanded && expanded !== internalExpanded) {
  //     setInternalExpanded(expanded);
  // }


  var onClickCloser = (0, _react.useCallback)(function () {
    overlay && overlay.setPosition(undefined);
    popupCloserRef.current && popupCloserRef.current.blur();
    onClose && onClose();
  }, [overlay, onClose]);
  /**
  * Effect to add overlay in the map
  */

  (0, _react.useEffect)(function () {
    if (popupRef.current && !overlay) {
      var newOverlay = new _Overlay.default({
        element: popupRef.current,
        //positioning: 'bottom-center',
        //stopEvent: false,
        autoPan: true,
        autoPanAnimation: {
          duration: 250
        }
      });
      setOverlay(newOverlay);
      map.addOverlay(newOverlay);
    }

    return function () {
      map.removeOverlay(overlay);
    };
  }, [overlay, map]);
  /**
   * Effect to add position to overlay
   */

  (0, _react.useEffect)(function () {
    if (position && overlay && position !== overlay.getPosition()) {
      overlay.setPosition(position);
    }
  }, [overlay, position]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, otherProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ref: popupRef,
      className: "rolext-popup",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: popupCloserRef,
        onClick: onClickCloser,
        className: "rolext-popup-closer"
      }), children]
    })
  }));
};

BasePopup.propTypes = {
  /**
   * The OpenLayers ol/Map on where the popup will be rendered.
   */
  map: _propTypes.default.instanceOf(_ol.Map),

  /**
   * [x,y] representing the position on the 
   * map where the popup will be shown
   */
  position: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * The content of the popup
   */
  children: _propTypes.default.node,

  /**
   * Event handler called once the user
   * closes the popup
   */
  onClose: _propTypes.default.func
};
var _default = BasePopup;
exports.default = _default;